export const EQUITY_ELITE = 'EE'
export const HOMESAFE = 'HomeSafe'